import Cookies from "js-cookie";
import { AppInterface, LiteUserInfo } from "../interfaces/AppInterface";
let application: AppInterface = null;

export type AuthTicketType = {
  t: number;
  k: string;
};

export const jsonSafeGet = <T>(jsonString: any, defaultData = {}): T => {
  let output = defaultData as T;
  try {
    output = JSON.parse(jsonString);
  } catch (e) {
    // do nothing.
  }
  return output;
};

export const isDeviceMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent || ""
  );
};

export const getCookies: () => AppInterface = () => {
  if (application) return application;
  application = {
    userInfo: jsonSafeGet<LiteUserInfo>(Cookies.get("userInfo")),
    tgtTimestamp:
      jsonSafeGet<AuthTicketType>(Cookies.get("auth")).t ||
      Cookies.get("tgt_timestamp"),
    tgtTicket:
      jsonSafeGet<AuthTicketType>(Cookies.get("auth")).k ||
      Cookies.get("tgt_ticket"),
    ecountry: Cookies.get("ecountry") ?? "jo",
    source:
      Cookies.get("source") ||
      Cookies.get("source") ||
      (isDeviceMobile() ? "mobile" : "desktop"),
    device_uuid: Cookies.get("device_uuid") ?? "",
    NEXT_LOCALE: Cookies.get("NEXT_LOCALE") ?? "ar",
    VIEWED_LISTING_COOKIE: Cookies.get("recentlyViewed") ?? "recentlyViewed",
    audience:
      Cookies.get("source") || (isDeviceMobile() ? "mobile" : "desktop"),
    cityId: Cookies.get("cityId") || "",
  };
  return application;
};

export const defaultOptions = {
  expires: process.env.REACT_APP_DEFAULT_COOKIES_EXPIRED_IN_MINUTES,
  path: "/",
  ...(typeof window !== "undefined"
    ? window.location.hostname.includes("localhost")
      ? { domain: window.location.hostname }
      : {
          domain:
            "." +
            window.location.hostname.split(".").reverse()[1] +
            "." +
            window.location.hostname.split(".").reverse()[0],
        }
    : {}),
};

export const setCookie = (name: string, value: string, options: any) => {
  // Default values for options:
  let { expires = "", path = "/", domain = "" } = options;

  // If expires is a number, convert it to minutes and create a Date object:
  if (typeof expires === "number") {
    const minutes = expires;
    const now = new Date();
    now.setTime(now.getTime() + minutes * 60 * 1000);
    expires = now;
  }

  // Construct the cookie string:
  let cookieString = `${name}=${value}`;

  if (expires instanceof Date) {
    cookieString += `;expires=${expires.toUTCString()}`;
  }

  if (path) {
    cookieString += `;path=${path}`;
  }

  if (domain) {
    cookieString += `;domain=${domain}`;
  }

  // Set the cookie:
  document.cookie = cookieString;
};

export const getGeneralImage = (imageName: string) => {
  if (!imageName) return "";
  return `${imageName.replace("{platform}", "ios").replace("{size}", "2x")}`;
};

export const myListingRedirect = () => {
  let domain = process.env.REACT_APP_OPENSOOQ_BASE_DOMAIN_SSO.replace(
    "jo",
    "my"
  );
  window.location.href = `${domain}/listings/my-listings`;
};

type style = {
  underline: boolean;
  bold: boolean;
};

export const generateStyleClasses = (style: style) => {
  if (!style) return "";
  return `${style?.underline ? " vas-text-decoration-underline" : ""}${
    style?.bold ? " vas-fw-bold" : ""
  }`;
};
